import { SET_FOOTER_CONFIG } from '@app/actions/_types';

const initialFooterState = {
  visible: false,
  onBack: undefined,
  onNext: undefined,
  backHidden: false,
  nextHidden: true,
  backDisabled: false,
  nextDisabled: false,
  nextLocKey: undefined,
  backLocKey: undefined,
  saveToYourAccount: false,
  showSaveToMyAccount: false,
};

export default (state = initialFooterState, { type, payload } = {}) => {
  if (type === SET_FOOTER_CONFIG) {
    return { ...state, ...payload };
  }
  return state;
};
